import _objectSpread from "reshow-runtime/es/helpers/objectSpread2";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import { createElement } from "react";

var Base = function Base(name) {
  var Atom = function Atom(props) {
    var ref = props.refCb,
        otherProps = _objectWithoutProperties(props, ["refCb"]);

    var myProps = props.hasOwnProperty("refCb") ? _objectSpread(_objectSpread({}, otherProps), {}, {
      ref: ref
    }) : props;
    return /*#__PURE__*/createElement(name, myProps);
  };

  Atom.displayName = "ATOM (".concat(name, ")");
  return Atom;
};

export default Base;